<div class="mdc-snackbar-component">
  <div class="icon" [innerHTML]="data.icon"></div>
  <div class="html-text">
    <span class="title" [innerHTML]="data.title"> </span>
    <span class="message" [innerHTML]="data.message"> </span>
    <div class="links">
      <a (click)="viewWorkspace()" class="view">{{ 'text.viewWorkspace' | transloco }}</a>
    </div>
  </div>

  <span class="action-btn" (click)="close()">x</span>
</div>
